import size from "../utills/size";

export const fontConfig = [
    { name: 'Montserrat', weight: 400, style: 'normal', file: 'Montserrat-Regular.woff2' },
    { name: 'MontserratBold', weight: 700, style: 'normal', file: 'Montserrat-Bold.woff2' },
    { name: 'MontserratBlack', weight: 900, style: 'normal', file: 'Montserrat-Black.woff2' },
    { name: 'MontserratMedium', weight: 500, style: 'normal', file: 'Montserrat-Medium.woff2' },
    { name: 'MontserratSemiBold', weight: 600, style: 'normal', file: 'Montserrat-SemiBold.woff2' },
    { name: 'MontserratLight', weight: 300, style: 'normal', file: 'Montserrat-Light.woff2' },
    // { name: 'Montserrat-Italic', weight: 400, style: 'italic', file: 'Montserrat-Italic.woff2' },
    // { name: 'Montserrat-BoldItalic', weight: 700, style: 'italic', file: 'Montserrat-BoldItalic.woff2' },
    // { name: 'Montserrat-MediumItalic', weight: 500, style: 'italic', file: 'Montserrat-MediumItalic.woff2' },
    // { name: 'Montserrat-SemiBoldItalic', weight: 600, style: 'italic', file: 'Montserrat-SemiBoldItalic.woff2' },
    // { name: 'Montserrat-LightItalic', weight: 300, style: 'italic', file: 'Montserrat-LightItalic.woff2' },
    { name: 'MontserratThin', weight: 100, style: 'normal', file: 'Montserrat-Thin.woff2' },
    // { name: 'Montserrat-ThinItalic', weight: 100, style: 'italic', file: 'Montserrat-ThinItalic.woff2' },
    { name: 'MontserratExtraBold', weight: 800, style: 'normal', file: 'Montserrat-ExtraBold.woff2' },
    // { name: 'Montserrat-ExtraBoldItalic', weight: 800, style: 'italic', file: 'Montserrat-ExtraBoldItalic.woff2' },
    { name: 'MontserratExtraLight', weight: 200, style: 'normal', file: 'Montserrat-ExtraLight.woff2' },
    // { name: 'Montserrat-ExtraLightItalic', weight: 200, style: 'italic', file: 'Montserrat-ExtraLightItalic.woff2' },
    // { name: 'Montserrat-BlackItalic', weight: 900, style: 'italic', file: 'Montserrat-BlackItalic.woff2' },
    // { name: 'Montserrat-BlackItalic', weight: 900, style: 'normal', file: 'Montserrat-BlackItalic.woff2' },
    // { name: 'Montserrat-ExtraBoldItalic', weight: 800, style: 'italic', file: 'Montserrat-ExtraBoldItalic.woff2' },
    // { name: 'Montserrat-ExtraLightItalic', weight: 200, style: 'italic', file: 'Montserrat-ExtraLightItalic.woff2' },
];

export const galleryOptions = {
    displayProps: {
        mode: "expanded",
        columns: 2,
        spacing: 10,
        infinite: true
    },
    viewportBreakpoints: [{
        breakpoint: size.md_const,
        mode: "classic",
        carouselStyle: 'none',
        navigation: 'none',
        carouselLoop: 'jump'
    }]
}

export const galleryOptionsQuickView = {
    displayProps: {
        mode: 'classic',
    },
    carouselLoop: 'jump',
    thumbnailProps: {
        width: 85,
        height: 87,
        spacing: 7,
        navigationShape: 'none',
        borderColor: 'transparent',
        selectedBorderPosition: 'all',
        navigationFloat: true,
        selectedGradientOpacity: 0.5,
        selectedStyle: 'gradient',
    },
    navigationButtonProps: {
        shape: 'round',
        size: 47,
        color: 'rgba(0, 0, 0, 0.5)',
        iconColor: 'white',
    },
}

export const RadiusInMiles = [
    { miles: 15, milesLable: '15 Miles' },
    { miles: 30, milesLable: '30 Miles' },
    { miles: 50, milesLable: '50 Miles' },
    { miles: 100, milesLable: '100 Miles' }
]